import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ManagementIsfShortModel } from '@data-layer/models/management';
import { enumIsfState } from '@data-layer/enums/isf/enumIsfState';
import { Observable } from 'rxjs';
import { GenericService } from '@services/generic.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'isf-list-admin',
  templateUrl: './isf-list-admin.component.html',
  styleUrls: ['./isf-list-admin.component.scss'],
})
export class IsfListAdminComponent implements OnInit {
  @Input() public isfList: Observable<ManagementIsfShortModel[]>;
  @Input() public isLoading: boolean = false;
  @Input() public total: number;
  @Input() public limit: number;
  @Input() public totalRows: number;
  @Input() public tableId: string | number = 'isf-list-admin';
  @Input() public page: number = 1;
  @Input() public showCompanyLink: boolean = true;
  @Output() public pageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public limitChanged: EventEmitter<number> = new EventEmitter<number>();

  public enumIsfState: typeof enumIsfState = enumIsfState;
  public paginationMaxSize$: Observable<number>;

  constructor(private genericService: GenericService) {
    this.paginationMaxSize$ = this.genericService.isMobile$.pipe(map((isMobile) => (isMobile ? 5 : 7)));
  }

  public ngOnInit(): void {}

  public onPageChange(page: number) {
    this.page = page;
    this.pageChanged.emit(page);
  }
}
